import * as React from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from "../../hooks/useAuth";

export const SpreetailHeader: React.FC = () => {
  const history = useHistory();

  const handleHome = () => {
    history.push('/');
  };

  const location = useLocation();
  const { logout, isAuthenticated, isLoading } = useAuth();

  // Don't show logout button on login page
  const isLoginPage = location.pathname === '/login' || location.hash.includes('/login');

  if (isLoginPage || isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div style={{ 
      padding: '12px 20px', 
      display: 'flex', 
      justifyContent: 'space-between',
      alignItems: 'center',
      background: 'transparent'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px' 
      }}>
        <img 
          src="/assets/Spreetail_Logo_Text.png" 
          alt="Spreetail" 
          style={{ 
            height: '28px',
            objectFit: 'contain',
            cursor: 'pointer'
          }} 
          onClick={handleHome}
        />
      
      </div>
      {/* <button
        onClick={logout}
        className="text-white border-none rounded-md py-1.5 px-4 text-[13px] font-semibold transition-all duration-200 shadow-md cursor-pointer hover:bg-[#057A63] hover:-translate-y-px hover:shadow-lg flex items-center gap-2"
        style={{ 
          backgroundColor: '#068E75',
          boxShadow: '0 2px 4px rgba(6, 142, 117, 0.3)'
        }}
      >
        <LogoutIcon sx={{ fontSize: '16px', color: 'white' }} />
        Logout
      </button> */}
    </div>
  );
};

export default SpreetailHeader;


